import { useContext, useEffect, useState } from 'react';
import * as LicenceMasterService from "../../services/licenceMasterService";
import * as manageLoginServices from '../../services/manageLoginServices';
import { ThemeContext } from "../../layout/BaseLayout";

const ManageLogin = () => {
    let toast = useContext(ThemeContext);
    const [operatorList, setOperatorList] = useState([]);
    const [operCode, setOperCode] = useState('');
    const [disableUpdateStatusBtn, setDisableUpdateStatusBtn] = useState(true);
    const [disableForcedLogoutBtn, setDisableForcedLogoutBtn] = useState(true);

    const defaultObj = {
        "operatorId": "",
        "adminStatus": false,
        "dealerStatus": false,
        "clientStatus": false,
        "clientWebStatus": false,
    }
    const [manageLoginList, setManageLoginList] = useState(defaultObj);

    const defaultForceObj = {
        "operatorId": "",
        "userRole": []
    }
    const [forceLogoutObj, setForceLogoutObj] = useState(defaultForceObj);

    const getOperatorsForWhitelabel = () => {
        LicenceMasterService.getOperators().then((res) => {
            if (res.isSuccess) {
                setOperatorList(!!res && !!res.data && res.data);
            } else {
                toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
            }
        })
    }

    const getDetailsByOperator = (e) => {
        let isValid = true;
        if (e.target.value === '') {
            setDisableUpdateStatusBtn(true);
            setDisableForcedLogoutBtn(true);
            setManageLoginList(defaultObj);
            setForceLogoutObj(defaultForceObj);
            isValid = false;
        } else {
            setDisableForcedLogoutBtn(false);
        }
        if (isValid) {
            setDisableUpdateStatusBtn(false);
            manageLoginServices.getStatus(e.target.value).then((res) => {
                if (res.isSuccess) {
                    setDisableUpdateStatusBtn(false);
                    setManageLoginList(res.data);
                } else {
                    setDisableUpdateStatusBtn(false);
                }
            }).catch(e => {
                setDisableUpdateStatusBtn(false);
            })
        }
        setOperCode(e.target.value);
    }

    const onChange = (fld, val) => {
        setManageLoginList(prev => ({ ...prev, [fld]: val }));
    }

    const onChangeForceLogout = (role, checked) => {
        const updatedUserRole = checked
            ? [...forceLogoutObj.userRole, role]
            : forceLogoutObj.userRole.filter((r) => r !== role);

        const isAnyCheckboxChecked = updatedUserRole.length > 0;
        setDisableForcedLogoutBtn(!isAnyCheckboxChecked);
        setForceLogoutObj({
            operatorId: operCode,
            userRole: updatedUserRole,
        });
    };

    const updateStatus = () => {
        manageLoginServices.updateStatus(manageLoginList).then((res) => {
            if (res.isSuccess) {
                toast.success(res?.successMessage);
            } else {
                toast.error(res?.exception?.message);
            }
        })
    }

    const forcedLogoutBtn = () => {
        let body = {
            "operatorId": operCode,
            "userRole": forceLogoutObj.userRole
        }
        manageLoginServices.forceLogout(body).then((res) => {
            if (res.isSuccess) {
                setForceLogoutObj(defaultForceObj);
                setDisableForcedLogoutBtn(true);
                toast.success(res?.successMessage);
            } else {
                toast.error(res?.exception?.message);
            }
        })
    }

    useEffect(() => {
        getOperatorsForWhitelabel();
    }, [])

    return (
        <div id='tabs'>
            <div className="maintitle-box">
                <div className="w-25 d-inline-block">
                    <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/managelogin.svg"} alt="" />Manage Login</h2>
                </div>
            </div>

            <div className='mt-2'>
                <div className='mb-3'>
                    <table border="0" className='mt-4'>
                        <tbody>
                            <tr className=''>
                                <td className="text-right font11 v-align-baseline footerw-100 font-bold">Operator :</td>
                                <td className='' colSpan={4}>
                                    <select title="operatorId" className="inputborder font11 font11 h20 inputborder mb-2 ml-2 p-0 w-250 mb-2 ml-2 h20 p-0" name="operatorId" value={operCode} onChange={(e) => { getDetailsByOperator(e) }} autoFocus>
                                        <option value="">Select Operator</option>
                                        {!!operatorList && operatorList.length > 0 && operatorList.map((item, i) => {
                                            return (
                                                <option className={`${!item?.LicenseStatus ? 'dropdown-bg-color' : ''}`} key={item.operatorId} value={item.operatorId}>{item.operatorId + " - " + item.companyName}</option>
                                            )
                                        })}
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='thead-fixed'>
                <table className='mb-30 ml-3 new-data-asc-desc table table-bordered table-strip tab-400'>
                    <thead>
                        <tr className='thead-dard-bg'>
                            <th>Module</th>
                            <th>Status</th>
                            <th>Change Status</th>
                            <th>Force Logout</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='font-bold font-11'>Admin:</td>
                            <td>{!!manageLoginList?.adminStatus && manageLoginList?.adminStatus ? 'Active' : "Inactive"}</td>
                            <td>
                                <div className="ml-19">
                                    <label className="form-check-label">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="adminStatus"
                                            value={manageLoginList?.adminStatus}
                                            checked={manageLoginList?.adminStatus}
                                            onChange={(e) => onChange('adminStatus', e.target.checked)}
                                        />
                                    </label>
                                </div>
                            </td>
                            <td>
                                <div className="ml-19">
                                    <label className="form-check-label">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="Admin"
                                            checked={forceLogoutObj.userRole.includes('Admin')}
                                            onChange={(e) => onChangeForceLogout('Admin', e.target.checked)}
                                        />
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className='font-bold font-11'>Dealers:</td>
                            <td>{!!manageLoginList?.dealerStatus && manageLoginList?.dealerStatus ? 'Active' : "Inactive"}</td>
                            <td>
                                <div className="ml-19">
                                    <label className="form-check-label">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="dealerStatus"
                                            value={manageLoginList?.dealerStatus}
                                            checked={manageLoginList?.dealerStatus}
                                            onChange={(e) => onChange('dealerStatus', e.target.checked)}
                                        />
                                    </label>
                                </div>
                            </td>
                            <td>
                                <div className="ml-19">
                                    <label className="form-check-label">
                                        <input type="checkbox"
                                            className="form-check-input"
                                            name="Dealer"
                                            checked={forceLogoutObj.userRole.includes('Dealer')}
                                            onChange={(e) => onChangeForceLogout('Dealer', e.target.checked)}
                                        />
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className='font-bold font-11'>Clients:</td>
                            <td>{!!manageLoginList?.clientStatus && manageLoginList?.clientStatus ? 'Active' : "Inactive"}</td>
                            <td>
                                <div className="ml-19">
                                    <label className="form-check-label">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="clientStatus"
                                            value={manageLoginList?.clientStatus}
                                            checked={manageLoginList?.clientStatus}
                                            onChange={(e) => onChange('clientStatus', e.target.checked)}
                                        />
                                    </label>
                                </div>
                            </td>
                            <td>
                                <div className="ml-19">
                                    <label className="form-check-label">
                                        <input type="checkbox"
                                            className="form-check-input"
                                            name="Client"
                                            checked={forceLogoutObj.userRole.includes('Client')}
                                            onChange={(e) => onChangeForceLogout('Client', e.target.checked)}
                                        />
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className='font-bold font-11'>Client Web:</td>
                            <td>{!!manageLoginList?.clientWebStatus && manageLoginList?.clientWebStatus ? 'Active' : "Inactive"}</td>
                            <td>
                                <div className="ml-19">
                                    <label className="form-check-label">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="clientWebStatus"
                                            value={manageLoginList?.clientWebStatus}
                                            checked={manageLoginList?.clientWebStatus}
                                            onChange={(e) => onChange('clientWebStatus', e.target.checked)}
                                        />
                                    </label>
                                </div>
                            </td>
                            <td>
                                <div className="ml-19">
                                    <label className="form-check-label">
                                        <input type="checkbox"
                                            className="form-check-input"
                                            name="Client"
                                            checked={forceLogoutObj.userRole.includes('ClientWeb')}
                                            onChange={(e) => onChangeForceLogout('ClientWeb', e.target.checked)}
                                        />
                                    </label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={2}></td>
                            <td className='text-right'><button type="button" className="btnmain ml-3 btn btn-primary mr-2" disabled={disableUpdateStatusBtn} onClick={() => updateStatus()}>Update Status </button></td>
                            <td className='text-right'><button type="button" className="btnmain ml-3 btn btn-primary mr-2" disabled={disableForcedLogoutBtn} onClick={() => forcedLogoutBtn()}>Force Logout </button></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    )
}

export default ManageLogin;